import React, { useEffect, useState } from 'react';
import { GetAction } from './GetAction';
import { mediaUrl } from '../utils/mediaUrl';

function Slider() {
  const [banners, setBanners] = useState([]);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    const loadBanners = async () => {
      try {
        const res = await GetAction('get', {}, '/hero_banner/bannerList');
        const list = Array.isArray(res?.response) ? res.response : [];
        setBanners(list);
      } catch (error) {
        setBanners([]);
      } finally {
        setLoaded(true);
      }
    };

    loadBanners();
  }, []);

  if (!loaded) {
    return (
      <div className="hero-banner-loading bd-example">
        <div className="hero-banner-placeholder" />
      </div>
    );
  }

  if (banners.length === 0) {
    return null;
  }

  const carouselId = 'heroBannerCarousel';

  return (
    <div className="bd-example hero-banner-section">
      <div id={carouselId} className="carousel slide hero-banner-carousel" data-ride="carousel">
        <ol className="carousel-indicators">
          {banners.map((banner, index) => (
            <li
              key={banner.banner_id || index}
              data-target={`#${carouselId}`}
              data-slide-to={index}
              className={index === 0 ? 'active' : ''}
            />
          ))}
        </ol>
        <div className="carousel-inner">
          {banners.map((banner, index) => (
            <div
              key={banner.banner_id || index}
              className={`carousel-item${index === 0 ? ' active' : ''}`}
            >
              <img
                src={mediaUrl(banner.image_path)}
                className="d-block w-100 hero-banner-image"
                alt={banner.title || 'Hero banner'}
              />
              {(banner.title || banner.subtitle) && (
                <div className="carousel-caption d-none d-md-block">
                  {banner.title && <h5>{banner.title}</h5>}
                  {banner.subtitle && <p>{banner.subtitle}</p>}
                </div>
              )}
            </div>
          ))}
        </div>
        {banners.length > 1 && (
          <>
            <a
              className="carousel-control-prev"
              href={`#${carouselId}`}
              role="button"
              data-slide="prev"
            >
              <span className="carousel-control-prev-icon" aria-hidden="true" />
              <span className="sr-only">Previous</span>
            </a>
            <a
              className="carousel-control-next"
              href={`#${carouselId}`}
              role="button"
              data-slide="next"
            >
              <span className="carousel-control-next-icon" aria-hidden="true" />
              <span className="sr-only">Next</span>
            </a>
          </>
        )}
      </div>
    </div>
  );
}

export default Slider;
